<template>
  <div>
    <vue-cal locale="es" :hide-view-selector="false" :events="events" @cell-click="reserve" v-if="step===0"/>
    <h4 v-if="step!==0">Área: {{area.name}}</h4>
    <div v-if="step===1" class="ion-padding">
      <h4>Día y hora de reserva</h4>
      <div class="collection">
        <div class="collection-item">
          <strong>{{formatDate(timeSelected, 'DD/MM/YYYY')}}</strong>
        </div>
        <div class="collection-item">
          <strong>{{formatDate(timeSelected, 'HH:mm')}}</strong>
        </div>
      </div>
      <h4>Datos de reserva</h4>
      <div class="row">
        <div class="input-field col s12">
          <label class="active" for="time-end">Hora Fin</label>
          <select id="time-end" v-model="timeEnd" style="display: block !important" :class="{validate: true, invalid: errors.timeEnd!==undefined}">
            <option :value="opt" v-for="opt in timeOptions">{{opt}}</option>
          </select>
          <ul v-if="errors.timeEnd !== undefined">
            <li v-for="err in errors.timeEnd" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
        <div class="input-field col s12">
          <input id="number-people" v-model="numberPeople" type="number" min="10" :max="area.capacity" label-placement="floating" value="10" :class="{validate: true, invalid: errors.numberPeople!==undefined}"/>
          <label class="active" for="number-people">Cantidad de personas</label>
          <ul v-if="errors.numberPeople !== undefined">
            <li v-for="err in errors.numberPeople" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
        <div class="input-field col s12">
          <input id="nchairs" :class="{validate: true, invalid: errors.nChairs!==undefined}" type="number" v-model="nChairs" min="0" :max="maxChairs" label-placement="floating"/>
          <label class="active" for="nchairs">Alquiler de sillas (adicionales)</label>
          <span class="helper-text">Disponibles: {{maxChairs}}</span>
          <ul v-if="errors.nChairs !== undefined">
            <li v-for="err in errors.nChairs" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
      </div>
      <button class="btn waves-effect waves-light green" @click="nextPersonalData">Siguiente</button>
      <button class="btn waves-effect waves-light red" @click="step=0">Seleccionar otra fecha</button>
    </div>
    <div v-if="step===2" class="ion-padding">
      <div class="row">
        <div class="input-field col s12">
          <input v-model="dataRecord.fullname" label="Nombre completo" label-placement="floating"/>
          <label class="active" for="nchairs">Nombre completo</label>
          <ul v-if="errors.fullname !== undefined">
            <li v-for="err in errors.fullname" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
        <div class="input-field col s12">
          <input v-model="dataRecord.document_number" label="Nro de documento" label-placement="floating"/>
          <label class="active" for="nchairs">Nro de documento</label>
          <ul v-if="errors.document_number !== undefined">
            <li v-for="err in errors.document_number" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
        <div class="input-field col s12">
          <input v-model="dataRecord.email" type="email" label="Correo electrónico" label-placement="floating"/>
          <label class="active" for="nchairs">Correo electrónico</label>
          <ul v-if="errors.email !== undefined">
            <li v-for="err in errors.email" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
        <div class="input-field col s12">
          <input v-model="dataRecord.phone" type="tel" label="" label-placement="floating"/>
          <label class="active" for="nchairs">Nro de Whatsapp</label>
          <ul v-if="errors.phone !== undefined">
            <li v-for="err in errors.phone" :key="err"><span class="new badge red" data-badge-caption="">- {{ err }}</span></li>
          </ul>
        </div>
      </div>
      <button class="btn waves-effect waves-light green" @click="goPreview">Confirmar reserva</button>
      <button class="btn waves-effect waves-light red" @click="step=1">Volver</button>
    </div>
    <div v-if="step===3" class="ion-padding">
      <div class="collection">
        <div class="collection-item">
          <ion-label><strong>Precio: </strong>{{ dataRecord.price }}</ion-label>
        </div>
        <div class="collection-item">
          <label>{{ dataRecord.fullname }}</label>
        </div>
        <div class="collection-item">
          <label><strong>C.I: </strong>{{ dataRecord.document_number }}</label>
        </div>
        <div class="collection-item">
          <label>{{ dataRecord.email }}</label>
        </div>
        <div class="collection-item">
          <label><strong>Whatsapp: </strong>{{ dataRecord.phone }}</label>
        </div>
        <div class="collection-item">
          <label><strong>Horario: </strong>{{ formatDate(dataRecord.start_datetime, 'DD/MMM/YYYY HH:mm') }} a {{ formatDate(dataRecord.end_datetime, 'HH:mm') }}</label>
        </div>
        <div class="collection-item">
          <label><strong>Nro de Invitados: </strong>{{ dataRecord.people_count }}</label>
          <label><strong>Alquiler de sillas adicionales: </strong>{{ dataRecord.nChairs }}</label>
        </div>
      </div>
      <button class="btn waves-effect waves-light green" @click="save">Registrar reserva</button>
      <button class="btn waves-effect waves-light red" @click="step=2">Volver</button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { formatDate } from '../utils/util'
import { bindEvent, subscribeChannel } from '../services/pusher'
import { db } from '../services/firebasec'
import { addDoc, collection, onSnapshot, query, where } from 'firebase/firestore'
import api from '../services/api'
import * as moment from 'moment'

export default Vue.extend({
  name: 'ReservationForm',
  props: {
    area: {
      type: Object,
      default: () => ({})
    },
    submitAction: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      timeEnd: '',
      numberPeople: 10,
      nChairs: 0,
      maxChairs: 10,
      step: 0,
      timeSelected: new Date(),
      timeOptions: [],
      channel: null,

      dataRecord: {
        start_datetime: new Date(),
        end_datetime: new Date(),
        nChairs: 0,
        people_count: 0,
        price: 0.0,
        socialarea_id: 0,
        fullname: '',
        document_number: '',
        email: '',
        phone: '',
      },

      events: [],
      error: null,
      errors: []
    }
  },

  // 🔹 Lifecycle hooks
  mounted() {
    this.firebaseInit()
    this.pusherInit()
    this.dataRecord.socialarea_id = this.area.id
    this.loadData()
  },

  // 🔹 Methods
  methods: {
    async loadData() {
      try {
        const response = await api.get(`/social-areas/${this.area.id}/reservations`)
        this.events = response.data.records
      } catch (error) {
        console.error(error)
      }
    },
    firebaseInit() {
      const vm = this
      const colRef  = collection(db, "reservations")
      const q = query(colRef , where("area_id", "==", vm.area.id))
      onSnapshot(q, (snapshot) => {
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();
          //console.log('Reservas públicas actualizadas:', data);
          vm.events = data.reservations.filter((el) => {
            return el.socialarea_id === vm.dataRecord.socialarea_id
          })
          //console.log('Eventos: ', vm.events)
          vm.$forceUpdate()
        }
        else {
          try {
            addDoc(colRef, {
              area_id: vm.area.id,
              reservations: [],
              last_update: new Date().toISOString()
            })
          } catch (e) {
            console.error("Error al inicializar documento:", e)
          }
        }
        const data = snapshot.docs[0].data()
      })
    },
    pusherInit() {
      const vm = this;
      vm.channel = subscribeChannel('reservations-area-public');
      bindEvent(vm.channel, 'socialareas.max-chairs', (data) => {
        //console.log('Reservas máximo de sillas para reservar:', data);
        vm.maxChairs = data.maxChairs;
        if(vm.nChairs > vm.maxChairs) {
          vm.nChairs = vm.maxChairs
        }
        vm.$forceUpdate();
      })
      vm.channel.bind_global((eventName, data) => {
        //console.log('Global:', eventName, data);
      });
    },
    async reserve(day) {
      const dateVal = moment(day)
      this.timeSelected = dateVal.minutes(0)
      //console.log("reserve", this.timeSelected)
      const response = await api.post('/reservations/max-hour', { socialarea_id: this.area.id, date: this.timeSelected })
      this.timeOptions = response.data.options
      this.timeEnd = this.timeOptions[0]
      this.step = 1
    },
    async nextPersonalData() {
      this.dataRecord.price = parseFloat(this.area.price)
      let costChairs = this.area.condominium.last_chair_historial!==undefined ? this.nChairs * parseFloat(this.area.condominium.last_chair_historial.chair_price) : 0

      if(costChairs) {
        this.dataRecord.price += costChairs
      }
      this.dataRecord.price = this.dataRecord.price.toFixed(2)
      this.step = 2
    },
    async goPreview() {
      const endDateTime = moment(this.timeSelected)
      endDateTime.set('hour', this.timeEnd.split(':')[0])
      endDateTime.set('minute', this.timeEnd.split(':')[1])
      this.dataRecord.start_datetime = this.timeSelected
      this.dataRecord.end_datetime = endDateTime.toDate()
      this.dataRecord.nChairs = this.nChairs
      this.dataRecord.people_count = this.numberPeople
      this.step = 3
    },
    async save() {
      try {
        const response = await api.post('/reservations/public', this.dataRecord)
        //console.log('Respuesta: ', response)
        this.step = 0
        if (this.submitAction) {
          this.submitAction()
        }
      } catch (error) {
        console.error(error)
        if(error.status === 422) {
          this.errors = error.response.data.messages
          //console.log('Errores de validación:', error.response.data.messages, this.errors)
          if(this.errors.nChairs !== undefined) {
            this.step = 1
          }
          if(this.errors.numberPeople !== undefined) {
            this.step = 1
          }
          if(this.errors.timeEnd !== undefined) {
            this.step = 1
            this.reserve(this.timeSelected)
          }
          if(this.errors.email !== undefined) {
            this.step = 2
          }
          if(this.errors.fullname !== undefined) {
            this.step = 2
          }
          if(this.errors.document_number !== undefined) {
            this.step = 2
          }
          if(this.errors.phone !== undefined) {
            this.step = 2
          }
        }
      }
    },
    formatDate(date, format) {
      return formatDate(date, format)
    }
  }
})
</script>